import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronLeft } from "lucide-react";
import Navbar from "../../Landing/Navbar";

export default function SettingsLayout({ title, description, children, action }) {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main className="page-container max-w-5xl pt-3 pb-app-nav sm:pt-6 lg:pt-8">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-4 flex flex-col gap-3 sm:mb-6 sm:flex-row sm:items-end sm:justify-between"
        >
          <div>
            <Link
              to="/settings"
              className="inline-flex min-h-9 items-center gap-1.5 rounded-full border border-sand-200 bg-white px-3.5 py-2 text-[12px] font-semibold text-ink-600 transition hover:border-brand-600 hover:text-brand-600"
            >
              <ChevronLeft size={15} /> Settings
            </Link>
            <h1 className="mt-3 font-display text-[25px] font-bold leading-tight text-ink-800 sm:text-3xl">
              {title}
            </h1>
            {description && (
              <p className="mt-1 max-w-2xl text-[13px] leading-5 text-ink-500 sm:leading-6">
                {description}
              </p>
            )}
          </div>
          {action}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.05 }}
        >
          {children}
        </motion.div>
      </main>
    </div>
  );
}
